import { userDictionaryList } from '@/api/dictionary'
import store from '@/store/index'
function getDict(dictType) {
  var cache = store.getters.dictMap[dictType]
  if (!cache) {
    store.commit('dict/ADD_DICT', { dictType: dictType, dict: [] })
    cache = store.getters.dictMap[dictType]
    userDictionaryList(dictType).then(data => {
      store.commit('dict/ADD_DICT', { dictType: dictType, dict: data })
    }).catch(() => {
    })
  }
  return cache
}
async function getDictAsync(dictType) {
  var cache = store.getters.dictMap[dictType]
  if (!cache) {
    store.commit('dict/ADD_DICT', { dictType: dictType, dict: [] })
  }
  if (cache && cache.length > 0) {
    return cache
  } else if (!cache) {
    const data = await userDictionaryList(dictType)
    store.commit('dict/ADD_DICT', { dictType: dictType, dict: data })
    return data
  }
}
function dictLabel(dictType, value) {
  getDict(dictType)
  store.commit('dict/PLACEHOLD_LABEL', { dictType: dictType, value: value })
  return store.getters.dictLabel[dictType][value]
}
const install = function(Vue, options) {
  Vue.prototype.getDict = getDict
  Vue.prototype.getDictAsync = getDictAsync
  Vue.prototype.dictLabel = dictLabel
}
export default {
  install
}
